module.exports = __webpack_public_path__ + "0782a41e2b5d85396808089615ca9e10.svg";